/* eslint-disable max-len */
import { React, useState, useEffect, useRef, useContext } from 'react'
import TextArea from '../../../components/TextArea'
import { handleIsAddModal, resetOrgList } from "../../ManageOrganizationUsers/userSlice"
import { handleIsMonitorAddModal, resetMonitorList } from "./Components/monitorsSlice"
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import Toast from '../../../components/Toast'
import Emptyscreen from '../../../components/EmptyScreen'
import GlobalContext from "../../../components/Context/GloablContext"
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import Loader from '../../../components/Loader'
import { useSelector, useDispatch } from 'react-redux';
import { convertEpochToDateFormat } from '../../../CommonMethods/convertEpochToDateFormat'
import { useAddNotesMutation, useViewPatientQuery } from '../../../slices/patientSlice'
import { useParams } from "react-router-dom"
import { motion } from 'framer-motion'
import CustomOverLay from '../../../components/CustomOverLay'
import { BeatLoader } from 'react-spinners'
import { dataService } from '../../../services/data.services'
import Throttle from '../../../CommonMethods/Throttle'

export default function MedicalNotes({
    medicalNotes,
    setMedicalNotes,
    setIsAnyFieldFilled,
    edit,
    setEmptyField,
    emptyField,
    addPatientDetails,
    handleTabChange,
    patient_id
}) {
    const [addNotes] = useAddNotesMutation()
    const [isAddnote,setIsAddNote] = useState(false)
    const [confirmation,setConfirmation] = useState(false)
    const [confirmationState,setConfirmationState]=useState(false)
    const {setToastmessage} = useContext(GlobalContext)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const outsideClickRef = useRef();
    const [loading,setLoading] = useState(false)
    const [toastErrorMessage,setToastErrorMessage] = useState('')
    const [newNotesAdded, setNewNotesAdded] = useState('')

    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [count,setCount]=useState('')


    function handleOnChangeInput(id,option){
        setIsAnyFieldFilled(true)
        setMedicalNotes((prev) => ({
            ...prev,
            medical_Notes: option,
        }));
    }


    function handleEditOnChangeInput(id, value) {
        // Set throttle delay to 100 milliseconds
        const throttleDelay = 100;
    
        // Throttle the function to limit the frequency of updates
        const throttledHandleEditOnChangeInput = Throttle((id, value) => {
            setEmptyField(false);
            setIsAnyFieldFilled(true);
            setMedicalNotes((prev) => ({
                ...prev,
                medical_Notes: value,
            }));
            setNewNotesAdded(value);
        }, throttleDelay);
    
        // Call the throttled function with the provided arguments
        throttledHandleEditOnChangeInput(id, value);
    }
  
    useEffect(() => {
        fetchData('initial');
        
    }, []);

    useEffect(() => {
        if (items.length > 0) {
            const initialCollapsedState = items.map((_, index) => index !== 0);
            setCollapsedNotes(initialCollapsedState);
        }
    }, [items]);


    const [collapsedNotes, setCollapsedNotes] = useState(items.map((_, index) => index !== 0));
    const handleCollapseToggle = (index) => {
        setCollapsedNotes(prev => {
            const newCollapsedNotes = [...prev];
            newCollapsedNotes[index] = !newCollapsedNotes[index];
            return newCollapsedNotes;
        });
    };

    const fetchData = async(isInitial) => {
        if (!hasMore) return;
        setIsLoading(true);
        try{

            const res = await dataService.PostAPI('',`patients/list-wellness-note?type=medical-note&patient_id=${patient_id}&page_number=${page}&limit=15`)
            
            setCount(res?.data?.data?.totalCount)
            if(res?.data?.data?.totalCount>=0){
                if (res?.data?.data?.patientData?.length === 0) {
                    setIsLoading(false)
                    setHasMore(false); // No more data available
                }
                
                setItems(prevItems=>[...prevItems,...res?.data?.data?.patientData])
                setPage(prevPage => prevPage + 1);
                setIsLoading(false);
            }
        }catch(error){
            setIsLoading(false);
        }
       
    };

    const handleScroll = () => {
        const scrollArea = document.getElementById('device_scrollarea');
        const { scrollTop, clientHeight, scrollHeight } = scrollArea;
    
        // Adjust for small precision differences due to zoom (use a threshold)
        const scrollThreshold = 10;
    
        if (scrollHeight - scrollTop - clientHeight <= scrollThreshold && !isLoading) {
            fetchData();
        }
    };

    useEffect(() => {
        const adjustTextareaHeight = () => {
            const textareas = document.querySelectorAll('.auto-height-textarea');
          
            textareas.forEach((textarea) => {
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        };
    
        // Call the adjustTextareaHeight function after the initial render
        adjustTextareaHeight();
    
        // Attach the adjustTextareaHeight function to the resize event to handle dynamic content changes
        window.addEventListener('resize', adjustTextareaHeight);
    
        // Clean up the event listener to prevent memory leaks
        return () => {
            window.removeEventListener('resize', adjustTextareaHeight);
        };
    }, [items,collapsedNotes]);


    function handleSaveButton(){
        if (!newNotesAdded || newNotesAdded.medical_Notes === "") {
            // Field is empty, handle accordingly (show error message, prevent action, etc.)
            setEmptyField(true);
            setToastErrorMessage("Please fill the mandatory field");
            return; // Prevent further execution
        }
        // Field is not empty, proceed with saving and applying
        setConfirmationState(true); 
        setIsAddNote(false);
        setConfirmation(false);
      
    }

    const handleAppendNotes = async() => {
        setLoading(true)
        // Check if the administrativeNotes is an array
        let body = {
            "note_type": "medical-note",
            "description": newNotesAdded,
            "patient_id": addPatientDetails.patient_id
        }
        const response = await addNotes(body)
        if(response.data){
            setToastmessage(response.data.message); // Set success message
            setConfirmationState(false);
            handleTabChange('medical_notes')
            setLoading(false)
            setNewNotesAdded('')
            setMedicalNotes('')
            fetchData()
        } else {
            setLoading(false)
            setToastErrorMessage(response.data.message); // Set error message
            setConfirmationState(false);
            setEmptyField(false);
            setNewNotesAdded('')

        }
    }
    const user_type_labels = {
        "admin-user": "Admin",
        "super-admin": "Super Admin",
        "corporate-user": "Corporate",
        "organization-user":"Organization User",
        "provider":"Provider",
        "observer":"Observer",
        "monitor-user": "Monitor",
    }
    
    return (
        <div className='bg-white'>
            <motion.div
                className="mt-1"
                animate={{ x: 0 }}
                // initial={{ x: -10 }}
                transition={{ duration: 0.5 }}
            >
                <div className='h-[calc(100vh-435px)]'>
                    {!edit && (
                        <TextArea 
                            PatientNotes={true}
                            label={''}
                            htmlFor={'medical_Notes'}
                            id={'medical_Notes'}
                            value={medicalNotes?.medical_Notes}
                            placeholder={'Type note here...'}
                            emptyField={false}
                            handleOnChangeInput={handleOnChangeInput}
                        />
                    )}
                    {edit && (
                        <div>
                            {items.length===0&&isLoading ?            
                                <CustomOverLay Active text="Loading Medical Notes..." classKey={`right-20  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-full h-[calc(100vh-430px)]`} /> :
                                <>  
                                    {count>0 && 
                                    <div className='flex sticky top-0 left-0 pb-0.5 bg-white z-30 justify-end'>
                                        <button type='button' id='collapse_all' className='text-[16px] text-[#008586] leading-normal font-normal' onClick={() => setCollapsedNotes(new Array(items.length).fill(true))}>
                                            <span className='cursor-pointer'>Collapse All</span>
                                        </button>
                                        <button type='button' id='expand_all' className='pl-[16px] text-[16px] text-[#008586]  leading-normal font-normal' onClick={() => setCollapsedNotes(new Array(items.length).fill(false))}>
                                            <span className='cursor-pointer'>Expand All</span>
                                        </button>
                                    </div>
                                    }
                                    <div id={"device_scrollarea"} onScroll={handleScroll} className='max-h-[calc(100vh-501px)] overflow-auto scrollbar_grayw6 pr-2'>
                                        {items.map((note, index) => (
                                            <div key={index}>
                                                <div className='bg-[#E5F3F3] w-full items-center py-2 rounded-[4px] mt-[7px] flex px-4 cursor-pointer' onClick={() => handleCollapseToggle(index)}>
                                                    <p className='text-[18px] text-[#000] font-normal leading-normal'>
                                                        {note?.last_name}{note?.last_name ? ',' : ''} <span className='pl-1'>{note?.first_name}</span> <span className='pl-1'>
                                                            ({user_type_labels[note.user_type] || note.user_type})
                                                        </span>
                                                    </p>
                                                    <p className='text-[14px] pl-[24px] text-[#52555D] font-normal leading-normal'>{convertEpochToDateFormat(note.created_at,dateformat)}</p>
                                                    <img className={`ml-auto cursor-pointer rotate ${!collapsedNotes[index] ? "rotate-180" : 'rotate-0'}`} src="/images/collapse.svg" alt="collapse" />
                                                </div>
                                                {!collapsedNotes[index] && (
                                                    <textarea
                                                        readOnly
                                                        value={note.description}
                                                        className='text-[16px] py-2 text-[#000000] font-normal w-full outline-0 resize-none auto-height-textarea text-justify'
                                                    />
                                                )}
                                            </div>
                                        ))}
                                        {items.length>0&&isLoading&&<div className="flex justify-center my-2">
                                            <BeatLoader color='#972E4C'/>
                                        </div>}
                                    </div>
                                    {count>0 && 
                                        <div className='flex items-center mt-3 justify-end'>
                                            <button
                                                onClick={() => { setConfirmation(true) }}
                                                type='button'
                                                id='append_note'
                                                className="px-[15px] py-2.5 rounded-[15px] flex items-center hover:bg-[#E7EAF4] text-base font-normal text-[#000000]">
                                                <img src="/images/add-plus-red.svg" alt="add icon" />
                                                <span className='pl-2'>Append Note</span>
                                            </button>
                                        </div>   
                                    }   
                                </>
                            }
                            {items?.length===0&&!isLoading&& 
                            <>
                                <div className='flex items-center justify-end'>
                                    <button
                                        onClick={() => { setConfirmation(true) }}
                                        type='button'
                                        id='append_note'
                                        className="px-[15px] py-2.5 rounded-[15px] flex items-center hover:bg-[#E7EAF4] text-base font-normal text-[#000000]">
                                        <img src="/images/add-plus-red.svg" alt="add icon" />
                                        <span className='pl-2'>Append Note</span>
                                    </button>
                                </div>
                                <div className='h-full flex justify-center items-center'> 
                                    <Emptyscreen
                                        PatientNotes={true}
                                        title={"Manage Patients"}
                                        FirstPTag={"No Medical notes to view yet."}
                                        SecondePTag={"Start managing by clicking 'Append Note'"}
                                    />
                                </div>
                            </> }
                        </div>
                    )

                    }
                    {confirmation && 
                    <AnimatedModel key="edit-model"
                        Children={
                            <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                                <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                                    <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px] pt-[24px] pb-5 relative">
                                        <div className="flex justify-between pb-[16px] ">
                                            <h1 className='text-2xl font-normal text-[#000]'>Medical Note</h1>
                                            <img 
                                                onClick={() => {
                                                    setConfirmation(false);
                                                    setEmptyField(false);
                                                    setNewNotesAdded('')
                                                    setMedicalNotes('')
                                       
                                                }}   src='/images/close_icon.svg' className='cursor-pointer'/>
                                        </div>  
                                        <div className='pl-4 2xl:pl-[20px]  border border-[#C5C9DA] rounded-[8px] pr-4 pb-5 pt-2 overflow-auto overflow-x-hidden scrollbar_grayw6 h-customh12'>
                                            <TextArea
                                                PatientNotes={true}
                                                dataTestid={'medical-Notes'}
                                                htmlFor={'medical_Notes'}
                                                id={'medical_Notes'}
                                                value={medicalNotes?.medical_Notes}
                                                placeholder={'Type note here...'}
                                                emptyField={ emptyField && newNotesAdded.medical_Notes ==="" && newNotesAdded.medical_Notes ===undefined}
                                                handleOnChangeInput={handleEditOnChangeInput}
                                                handleOnCLickActivate={''}
                                                add={isAddnote}
                                                loadingActivation={false}
                                            />

                                        </div>
                                
                                        <div className='px-2.5 flex justify-end pt-3'>
                                            <button
                                                loading={loading} 
                                                disabled={newNotesAdded.trim() === "" || newNotesAdded === undefined}
                                                id={'update'}
                                                onClick={handleSaveButton}
                                                className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>Save & Apply</button>
                                        </div>
                                    </div>
                           
                                </div>
                                {
                                    toastErrorMessage!==''&&<Toast
                                        message={toastErrorMessage}
                                        type='error'
                                        setToastmessage={setToastErrorMessage}
                                        modal={true}
                            
                                    />
                                }
                            </div>
                   
                        }
                    />  
                    }
                    {confirmationState && (
                        <AnimatedModel
                            Children={
                                <ConfirmationPrompt
                                    handleOnCLickActivate={handleAppendNotes}
                                    handleClose={() =>{ setConfirmationState(false),setNewNotesAdded(''),setMedicalNotes('')}} 
                                    tittle={'Append Medical Note'}
                                    message={'Are you sure you want to append note?'}
                                    buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                    CancelButton={'No'}
                                    disabled={loading}
                            
                                />
                            }
                        />
                    )}
                </div>
            </motion.div>
        </div>
    )
}